import React from 'react';
import { Box, Typography } from '@mui/material';
import WifiOffIcon from '@mui/icons-material/WifiOff';
import SyncIcon from '@mui/icons-material/Sync';

const ConnectionBanner = ({ isConnected, isReconnecting }) => {
  if (isConnected) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
        py: 0.5,
        bgcolor: isReconnecting ? '#ff9800' : '#f44336',
        color: '#fff',
        fontSize: '0.85rem',
      }}
    >
      {isReconnecting ? (
        <>
          <SyncIcon sx={{ fontSize: 16, animation: 'spin 1s linear infinite', '@keyframes spin': { from: { transform: 'rotate(0deg)' }, to: { transform: 'rotate(360deg)' } } }} />
          <Typography variant="body2" sx={{ color: 'inherit', fontWeight: 500 }}>
            Reconnecting...
          </Typography>
        </>
      ) : (
        <>
          <WifiOffIcon sx={{ fontSize: 16 }} />
          <Typography variant="body2" sx={{ color: 'inherit', fontWeight: 500 }}>
            Connection lost. Trying to reconnect...
          </Typography>
        </>
      )}
    </Box>
  );
};

export default ConnectionBanner;
